define(function(require) {
    // GEOCODER_ADRS layer definition config (utiliser avec SearchToolExtend.js)

    var _modifyFieldValue = function(key, index, obj) {
        return obj[key].split(" - ")[index];
    };

    return {
        LAYER_ID : "GEOCODER_ADRS",
        LAYER_TYPE : "POINT",
        LOADING_MODE : "ON_DEMAND",
        INDEX : 18,
        DATATABLE_ID : "t_GEOCODER_ADRS",
        SEARCH_VIEW: {
            QUERY_DATA: function(searchCriteria) {
                return {
                    q: searchCriteria,
                    type: "adresses",
                    geometry: 1,
                    field: "numero;suffix;route;municipalite;codePostal"
                };
            },
            CALCUL_FEATURE_ID: function(feature){
                return feature.properties.code;
            },
            CALCUL_FEATURE_TEXT: function(feature){
                var adresse = (feature.properties.suffix != null ? feature.properties.suffix : "") + feature.properties.numero + ", " + feature.properties.route + (feature.properties.codePostal != null ? (", " + feature.properties.codePostal) : "");
                return [adresse, feature.properties.municipalite].join(" - ");
            },
            CALCUL_GEOMETRY: function(feature){
                var coordinates = feature.geometry.coordinates;
                var x = coordinates[0] * 20037508.34 / 180,
                    y = Math.log(Math.tan((90 + coordinates[1]) * Math.PI / 360)) / (Math.PI / 180);
                y = y * 20037508.34 / 180;
                return [x, y];
            },
        },
        FIELDS : [
          {ID : "ID", NAME : "Id", DATA_TYPE : "STRING", VALUE : "{{ID}}"},
          {ID : "ADRESSE", NAME : "Adresse", DATA_TYPE : "STRING", VALUE : _modifyFieldValue.bind(this, "TEXT", 0)},
          {ID : "NOM_MUNCP", NAME : "Municipalité", DATA_TYPE : "STRING", VALUE : _modifyFieldValue.bind(this, "TEXT", 1)}
        ],
        STYLES : [
            {
                ID : "Adresses",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "SymbolPointSymbolizer",
                        COLOR : "rgba(255,255,255,1)",
                        FONT_NAME : "CartoVistaCartographic",
                        FONT_FILE_SOURCE : require("@meq/cartovista-extend/dist/assets/CartoVistaCartographic.ttf"),
                        SYMBOL_CHAR : "=",
                        SIZE : 14,
                        HAS_HALO : true,
                        HALO_COLOR : "rgba(0,0,0,1)",
                        Z_INDEX : 1
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(0,0,0,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 8,
                    VISIBLE : true
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Adresses",
            FEATURE_ID_DATACOLUMN : "ID",
            FEATURE_NAME_DATACOLUMN : "ADRESSE",
            DATATIP_DATACOLUMNS : ["ADRESSE"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : ["ADRESSE", "NOM_MUNCP"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["ADRESSE", "NOM_MUNCP"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            SEARCHABLE_DATACOLUMNS : ["ADRESSE", "NOM_MUNCP"],
            IS_VISIBLE_IN_LAYER_CONTROL : false,
            IS_VISIBLE_IN_LEGEND : false,
            SHOW_STYLES_IN_LAYER_CONTROL : false,
            LABEL_DATACOLUMN : "ADRESSE",
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : true,
                LEADER_LINES : false,
                POSITION : "MIDDLE-RIGHT",
                PRIORITY : 10
            },
            VISIBLE : true,
            ZOOM_ON_FEATURE_SCALE : 6000
        }
    };
});
